export enum ApplicableTaxFlights {
    Never = 0,
    DomesticOnly = 1,
    InternationalOnly = 2,
    All = 3,
}
